import { useHttpClient } from "@/common/api/httpClient";
import type { VehicleResponse } from "./models/vehicleResponse";
import { useLanguageStore } from "shared/translations/stores/languageStore";
import { storeToRefs } from "pinia";

export interface ListVehicleResponse {
  ok: true;
  vehicles: VehicleResponse[];
}

export function useListVehicles() {
  const httpClient = useHttpClient();
  const languageStore = useLanguageStore();
  const { translations } = storeToRefs(languageStore);

  return {
    execute
  };

  async function execute() {
    const headers = httpClient.defaultHeaders();
    const request = new Request(httpClient.siteUrl("vehicle"), {
      headers: headers,
      method: 'GET'
    });

    const text = translations.value.vehicles.actions.fetchMany;

    const response = await httpClient.action<ListVehicleResponse>(request, {
      title: text.title,
      errorTitle: text.error,
      async processOk(response) {
        const json = await response.json() as VehicleResponse[];
        return {
          ok: true,
          vehicles: json
        };
      },
    });

    return response;
  }
}

